// Reusable sort + company-filter controls for any ticket list dashboard -
// pairs with the useTicketFilters hook (src/hooks/useTicketFilters.js).
// showCompanyFilter is opt-in per page: customer-facing lists (a customer
// only ever sees their own company's tickets) don't need it, only the
// employee-facing lists that mix tickets from many companies do.
export default function TicketFilterBar({ sortBy, setSortBy, company, setCompany, companyOptions, showCompanyFilter = true, sortOptions }) {
  const options = sortOptions || [
    { value: 'date_desc', label: 'جدیدترین' },
    { value: 'date_asc', label: 'قدیمی‌ترین' },
    { value: 'company_asc', label: 'نام شرکت (الفبا)' },
    { value: 'priority_desc', label: 'اولویت' },
  ];

  const selectStyle = {
    padding: '7px 12px', border: '1.5px solid #e2e8f0', borderRadius: 10,
    fontSize: 12, outline: 'none', background: '#fff', fontFamily: 'inherit',
    cursor: 'pointer', color: '#334155',
  };

  return (
    <>
      <select value={sortBy} onChange={(e) => setSortBy(e.target.value)} style={selectStyle} aria-label="مرتب‌سازی">
        {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>

      {showCompanyFilter && companyOptions.length > 0 && (
        <select value={company} onChange={(e) => setCompany(e.target.value)} style={{ ...selectStyle, minWidth: 140 }} aria-label="فیلتر بر اساس شرکت">
          <option value="">همه شرکت‌ها</option>
          {companyOptions.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      )}
    </>
  );
}
